import { State } from "@client/ImperativeState";

export default function userIsAdmin(userId: string, context: State) {
  const { round, userProfiles } = context;
  const userIsRoundAdmin = round.members[userId]?.isRoundAdmin;
  const userIsSfcAdmin = userProfiles[userId]?.isSfcAdmin;
  return userIsRoundAdmin || userIsSfcAdmin;
}
